import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import NavigationBar from '../components/NavigationBar';
import Footer from '../components/Footer';
import '../styles/navbar.css'
import './css/treetify.css'

const Treetify = () => {

    useEffect(() => {
        const handleScroll = () => {
            const elements = document.querySelectorAll(".scroll-animate");
            const windowHeight = window.innerHeight;

            elements.forEach(el => {
                const positionFromTop = el.getBoundingClientRect().top;
                if (positionFromTop - windowHeight <= -100) {
                    el.classList.add("show");
                }
            });
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); 
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            {/* Header Section */}
            <div>
                <div className='col m-12'></div>
                <NavigationBar />
            </div>

            {/* Main Content of Treetify */}
            <div className="contents">
                <div className="logo scroll-animate">
                    <img src="/img/TreetifyLOGO.png" alt="Logo" className="icon scroll-animate" style={styles.logo} />
                </div>
                <h1 className="title-name scroll-animate">Treetify</h1>
                <h3 className="userManual scroll-animate">User's Manual</h3>
                <h3 className="howToInstall scroll-animate">How to Use the Application</h3>

                <h3 className="TRH1 scroll-animate">Main Menu</h3>
                <p className="TRP1 scroll-animate">Treetify’s main menu serves as the central navigation hub of the system's framework. 
                    It features a slider at the top, offering a quick demonstration of how 
                    the scanner works. Below the slider are buttons that lead to the Fruit T
                    ree Almanac and Propagation Techniques, positioned at the center
                    of the interface. At the bottom of the screen is the navigation bar, which includes 
                    options such as Gallery, More Species, Report Issues, Settings, 
                    and the primary Camera button for initiating scans.
                </p>
                
                <img src="/img/TRS1.png" alt="Logo" className="TRS1 scroll-animate" />

                <h3 className="TRH2 scroll-animate">Scanner</h3>
                <p className="TRP2 scroll-animate">The "Tips" button on the lower left offers guidance on 
                    capturing the object effectively for optimal fruit tree classification results. 
                    These tips cover aspects like lighting, composition, focus, stability, 
                    settings, angles, and maintaining patience.
                </p>
                <img src="/img/TRS2.png" alt="Logo" className="TRS2 scroll-animate" />

                <p className="TRP3 scroll-animate">The “camera” button provides access to the phone's
                     built-in camera, enabling users to capture images directly within the app. 
                     Before proceeding, the app prompts users to grant permission for camera access,
                      ensuring privacy and security compliance. This step is necessary for the 
                      application to function correctly and allows users to take photos needed for  
                      fruit tree classification. Once permission is granted, the camera interface 
                      opens, allowing image capture without leaving the app.
                </p>
                <img src="/img/TRS3.png" alt="Logo" className="TRS3 scroll-animate" />
                <img src="/img/TRS4.png" alt="Logo" className="TRS4 scroll-animate" />


                <p className="TRP4 scroll-animate">The “gallery” button, located in the lower right corner, 
                    allows the users to access their phone's built-in gallery. 
                    This option is useful if users prefer to select an existing image from their 
                    photo library instead of capturing a new one.
                </p>
                <img src="/img/TRS5.png" alt="Logo" className="TRS5 scroll-animate" />

                <h3 className="TRH3 scroll-animate">Results Interface</h3>
                <p className="TRP5 scroll-animate">The results interface displays the image captured by the user,
                     along with the fruit tree's common name and its brief description. 
                     Users can choose to either save the image within the application or 
                     explore additional information about the classified fruit tree on a shared 
                     website called {" "}
                     <Link className="link" to="/HomePage">Arboreatrix.</Link>
                </p>
                <img src="/img/TRS6.png" alt="Logo" className="TRS6 scroll-animate" />

                <h3 className="TRH4 scroll-animate">More Species</h3>
                <p className="TRP6 scroll-animate">The "More Species" button offers details about newly discovered
                     fruit trees that are not yet part of the trained datasets. 
                     This feature allows users to explore additional species outside the current 
                     database, helping to expand their knowledge. By selecting this option, users
                </p>
                <img src="/img/TRS7.png" alt="Logo" className="TRS7 scroll-animate" />

            </div>


            {/* Footer Section */}
            <footer className='footer1'>
                <Footer />
            </footer>
        </>
    );
};

// Styles
const styles = {
    logo: {
      width: '300px',
      height: '300px',
      objectFit: 'contain',
      borderRadius: '50%',
    },
  };

export default Treetify;